module.exports = __webpack_public_path__ + "img/num1.b3143119.png";